import styled from 'styled-components';

export const Content = styled.div`
  padding: 0.5rem;
  margin-left: 0.25rem;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
  background-color: #fff;
`;
